import { Btn, ProgressBar } from '@kkf/design'
import { TEAM_MEMBER_DETAIL } from '../data/team-details'
import { useT } from '../i18n'

/** The team-details page. */
export function TeamDetailsPage() {
  const t = useT()
  const member = TEAM_MEMBER_DETAIL

  return (
    <>
      {/* No banner and no breadcrumb (2026-09-21) — see `ContactPage` for the two things
          that travel with dropping one: the page's `<h1>`, which `Breadcrumb` used to
          carry, and `header.plainRoutes`, which nothing fails without. */}
      <div className="ul-section-spacing ul-plain-page-top">
        <div className="ul-container">
          <div className="ul-team-details">
            <div className="row justify-content-between gx-0 gy-3">
              <div className="col-md-5">
                <div className="ul-team-details-img wow animate__fadeInUp">
                  <img src={member.image} alt={t('alt.teamMember')} />
                </div>
              </div>
              <div className="col-md-6">
                {/* txt */}
                <div className="txt wow animate__fadeInUp">
                  {/* The page's one `<h1>`: this person's name, which is what the page is
                      about. It was an `<h3>` under `Breadcrumb`'s "Team Details". */}
                  <h1 className="ul-team-details-name ul-section-title">{member.name}</h1>
                  <h6 className="ul-team-details-role">{member.role}</h6>
                  <p className="ul-team-details-descr">{member.descr}</p>
                  <ul className="ul-team-details-infos">
                    {member.infos.map((info) => (
                      <li className="ul-team-details-info" key={info.href}>
                        <a href={info.href}>
                          <i className={`flaticon-${info.icon}`} /> {info.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                  {/* social links */}
                  <div className="ul-team-details-socials">
                    {member.socials.map((s) => (
                      <a key={s.icon} href={s.href} aria-label={s.label ?? s.icon}>
                        <i className={`flaticon-${s.icon}`} />
                      </a>
                    ))}
                  </div>

                  <div className="ul-team-details-experiences">
                    <h3 className="ul-donation-details-summary-title">{t('team.experience')}</h3>
                    <div className="experiences-wrapper">
                      {member.experiences.map((exp) => (
                        <div className="ul-team-details-experience" key={exp.title}>
                          <h6 className="experience-title">{exp.title}</h6>
                          <div className="ul-donation-progress-2">
                            <ProgressBar
                              value={exp.value}
                              barClassName="skill-progressbar"
                              labelClassName="skill-progress-label"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="ul-team-details-contact">
                    <h3 className="ul-donation-details-summary-title">{t('team.message')}</h3>
                    <form action="#" className="ul-contact-form ul-form" onSubmit={(e) => e.preventDefault()}>
                      <div className="row row-cols-2 row-cols-xxs-1 ul-bs-row">
                        <div className="col">
                          <div className="form-group">
                            <input type="text" name="name" id="ul-contact-name" placeholder={t('form.name')} />
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group">
                            <input type="email" name="email" id="ul-contact-email" placeholder={t('form.email')} />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <input type="tel" name="phone" id="ul-contact-phone" placeholder={t('form.phone')} />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <textarea name="message" id="ul-contact-msg" placeholder={t('form.message')} />
                          </div>
                        </div>
                        <div className="col-12">
                          <Btn type="submit" icon="fast-forward-double-right-arrows-symbol">
                            {t('contact.eyebrow')}
                          </Btn>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
